/// <amd-module name="TFS/DRITools/util/RawDataTypes" />

export interface OnePoint {
    x: Date;
    y: number;
}

export interface Line {
    key: string;
    values: OnePoint[];
    color?: string;
    active?: boolean;
}

export interface DataInfo {
    name: string;
    type: string;
    maxY: number;
    description: string | string[];
}
